import axios, { AxiosError, AxiosRequestConfig } from 'axios';
import config from '../../config/config';

export const whisApiAxiosInstance = axios.create({
  baseURL: config.api.url,
  headers: {
    'Cache-Control': 'no-cache',
    Pragma: 'no-cache',
    Expires: '0',
  },
  // Serialize arrays as repeated keys: key=a&key=b
  // instead of key[]=a&key[]=b or key[0]=a&key[1]=b.
  paramsSerializer: {
    indexes: null,
  },
  maxRedirects: 0,
});

// Intercept errors to extract the response data from AxiosError
// This allows TanStack Query to receive the typed error response directly
// instead of the full AxiosError instance
whisApiAxiosInstance.interceptors.response.use(
  (response) => response,
  (error: AxiosError) => {
    // If the error has response data, reject with just the data
    // This matches the error types generated by orval (e.g., StandardHttpErrorDto)
    if (error.response?.data) {
      return Promise.reject(error.response.data);
    }
    // For network errors or other cases without response data,
    // return a standardized error object
    return Promise.reject({
      statusCode: error.response?.status ?? 0,
      message: error.message,
      error: error.code ?? 'UNKNOWN_ERROR',
    });
  },
);

export function apiInstance<T>(
  config: AxiosRequestConfig,
  options?: AxiosRequestConfig,
): Promise<T> {
  const source = axios.CancelToken.source();
  const promise = whisApiAxiosInstance({
    ...config,
    ...options,
    cancelToken: source.token,
  }).then(({ data }) => data);

  return promise;
}
